'use strict'

/**
 * Module qui gère le carousel a multiple image
 * Doc on http://kenwheeler.github.io/slick/
 */

/**
 * Vérifie si l'élément est présent dans le DOM
 * @param {string} selector Selecteur CSS
 * @returns
 */
function elementExistsInDOM(selector) {
    return $(selector).length !== 0
}

/**
 * HOME / MAISON SECONDE
 */

const J_INFLUENCEURS_SLIDER = '.j_influenceurs_slider' // INFLUENCEURS HOME / MAISON SECONDE

function activerCarrouselInfluenceurs() {
    if (elementExistsInDOM(J_INFLUENCEURS_SLIDER)) {
        //nb of slides before slider is built, since slides are duplicated
        let nb_real_slides = $(
            J_INFLUENCEURS_SLIDER + ' .secondemain__influenceur'
        ).length
        let currentInfluenceur = 0
        let currentSlide = 0

        $(window).resize(function() {
            $(J_INFLUENCEURS_SLIDER)[0].slick.refresh()
            let current = $(
                J_INFLUENCEURS_SLIDER + ' .slick-slide.slick-current'
            ).attr('data-slick-index')
            let next = parseInt(current) + 1
            let prev = parseInt(current) - 1
            $(
                J_INFLUENCEURS_SLIDER +
                ' .slick-slide[data-slick-index=' +
                current +
                ']'
            )
                .addClass('influenceur-active')
                .addClass('no-transition')
            $(
                J_INFLUENCEURS_SLIDER +
                ' .slick-slide[data-slick-index=' +
                prev +
                ']'
            )
                .addClass('influenceur-prev')
                .addClass('no-transition')
            $(
                J_INFLUENCEURS_SLIDER +
                ' .slick-slide[data-slick-index=' +
                next +
                ']'
            )
                .addClass('influenceur-next')
                .addClass('no-transition')

            setTimeout(function() {
                $(J_INFLUENCEURS_SLIDER + ' .influenceur-active').removeClass(
                    'no-transition'
                )
                $(J_INFLUENCEURS_SLIDER + ' .influenceur-prev').removeClass(
                    'no-transition'
                )
                $(J_INFLUENCEURS_SLIDER + ' .influenceur-next').removeClass(
                    'no-transition'
                )
            }, 400)
        })

        $(J_INFLUENCEURS_SLIDER).slick({
            infinite: true,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            centerMode: true,
            lazyLoad: 'progressive',
            autoplay: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false
                    }
                }
            ]
        })
        $(J_INFLUENCEURS_SLIDER + ' .slick-slide[data-slick-index=0]').addClass(
            'influenceur-active'
        )
        $(
            J_INFLUENCEURS_SLIDER + ' .slick-slide[data-slick-index=-1]'
        ).addClass('influenceur-prev')
        $(J_INFLUENCEURS_SLIDER + ' .slick-slide[data-slick-index=1]').addClass(
            'influenceur-next'
        )
        $(
            J_INFLUENCEURS_SLIDER +
            ' .slick-slide[data-slick-index=' +
            nb_real_slides +
            ']'
        ).addClass('influenceur-active')
        $(
            J_INFLUENCEURS_SLIDER +
            ' .slick-slide[data-slick-index=' +
            parseInt(nb_real_slides - 1) +
            ']'
        ).addClass('influenceur-prev')
        $(
            J_INFLUENCEURS_SLIDER +
            ' .slick-slide[data-slick-index=' +
            parseInt(nb_real_slides + 1) +
            ']'
        ).addClass('influenceur-next')

        $(J_INFLUENCEURS_SLIDER).on(
            'beforeChange',
            function(event, slick, currentSlide, nextSlide) {
                if (currentSlide !== nextSlide) {
                    let current = nextSlide
                    let next = parseInt(current) + 1
                    let prev = parseInt(current) - 1

                    $('.influenceur-active')
                        .addClass('transition-active')
                        .removeClass('influenceur-active')
                    $('.influenceur-prev')
                        .addClass('transition-prev')
                        .removeClass('influenceur-prev')
                    $('.influenceur-next')
                        .addClass('transition-next')
                        .removeClass('influenceur-next')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        current +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        prev +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        next +
                        ']'
                    ).addClass('influenceur-next')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides) +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides - 1) +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides + 1) +
                        ']'
                    ).addClass('influenceur-next')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides) +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides - 1) +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEURS_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides + 1) +
                        ']'
                    ).addClass('influenceur-next')
                    $('.transition-active').removeClass('transition-active')
                    $('.transition-prev').removeClass('transition-prev')
                    $('.transition-next').removeClass('transition-next')
                }
                currentInfluenceur = nextSlide
            }
        )
    }
}

const J_INFLUENCEUSES_SLIDER = '.j_influenceurs_slider_2' // INFLUENCEURS HOME / MAISON SECONDE

function activerCarrouselInfluenceuses() {
    if (elementExistsInDOM(J_INFLUENCEUSES_SLIDER)) {
        //nb of slides before slider is built, since slides are duplicated
        let nb_real_slides = $(
            J_INFLUENCEUSES_SLIDER + ' .home-influ__influenceur'
        ).length
        let currentInfluenceur = 0
        let currentSlide = 0

        $(window).resize(function() {
            $(J_INFLUENCEUSES_SLIDER)[0].slick.refresh()
            let current = $(
                J_INFLUENCEUSES_SLIDER + ' .slick-slide.slick-current'
            ).attr('data-slick-index')
            let next = parseInt(current) + 1
            let prev = parseInt(current) - 1
            $(
                J_INFLUENCEUSES_SLIDER +
                ' .slick-slide[data-slick-index=' +
                current +
                ']'
            )
                .addClass('influenceur-active')
                .addClass('no-transition')
            $(
                J_INFLUENCEUSES_SLIDER +
                ' .slick-slide[data-slick-index=' +
                prev +
                ']'
            )
                .addClass('influenceur-prev')
                .addClass('no-transition')
            $(
                J_INFLUENCEUSES_SLIDER +
                ' .slick-slide[data-slick-index=' +
                next +
                ']'
            )
                .addClass('influenceur-next')
                .addClass('no-transition')

            setTimeout(function() {
                $(J_INFLUENCEUSES_SLIDER + ' .influenceur-active').removeClass(
                    'no-transition'
                )
                $(J_INFLUENCEUSES_SLIDER + ' .influenceur-prev').removeClass(
                    'no-transition'
                )
                $(J_INFLUENCEUSES_SLIDER + ' .influenceur-next').removeClass(
                    'no-transition'
                )
            }, 400)
        })

        $(J_INFLUENCEUSES_SLIDER).slick({
            infinite: true,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            centerMode: true,
            lazyLoad: 'progressive',
            autoplay: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false
                    }
                }
            ]
        })
        $(
            J_INFLUENCEUSES_SLIDER + ' .slick-slide[data-slick-index=0]'
        ).addClass('influenceur-active')
        $(
            J_INFLUENCEUSES_SLIDER + ' .slick-slide[data-slick-index=-1]'
        ).addClass('influenceur-prev')
        $(
            J_INFLUENCEUSES_SLIDER + ' .slick-slide[data-slick-index=1]'
        ).addClass('influenceur-next')
        $(
            J_INFLUENCEUSES_SLIDER +
            ' .slick-slide[data-slick-index=' +
            nb_real_slides +
            ']'
        ).addClass('influenceur-active')
        $(
            J_INFLUENCEUSES_SLIDER +
            ' .slick-slide[data-slick-index=' +
            parseInt(nb_real_slides - 1) +
            ']'
        ).addClass('influenceur-prev')
        $(
            J_INFLUENCEUSES_SLIDER +
            ' .slick-slide[data-slick-index=' +
            parseInt(nb_real_slides + 1) +
            ']'
        ).addClass('influenceur-next')

        $(J_INFLUENCEUSES_SLIDER).on(
            'beforeChange',
            function(event, slick, currentSlide, nextSlide) {
                if (currentSlide !== nextSlide) {
                    let current = nextSlide
                    let next = parseInt(current) + 1
                    let prev = parseInt(current) - 1

                    $('.influenceur-active')
                        .addClass('transition-active')
                        .removeClass('influenceur-active')
                    $('.influenceur-prev')
                        .addClass('transition-prev')
                        .removeClass('influenceur-prev')
                    $('.influenceur-next')
                        .addClass('transition-next')
                        .removeClass('influenceur-next')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        current +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        prev +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        next +
                        ']'
                    ).addClass('influenceur-next')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides) +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides - 1) +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current + nb_real_slides + 1) +
                        ']'
                    ).addClass('influenceur-next')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides) +
                        ']'
                    ).addClass('influenceur-active')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides - 1) +
                        ']'
                    ).addClass('influenceur-prev')
                    $(
                        J_INFLUENCEUSES_SLIDER +
                        ' .slick-slide[data-slick-index=' +
                        parseInt(current - nb_real_slides + 1) +
                        ']'
                    ).addClass('influenceur-next')
                    $('.transition-active').removeClass('transition-active')
                    $('.transition-prev').removeClass('transition-prev')
                    $('.transition-next').removeClass('transition-next')
                }
                currentInfluenceur = nextSlide
            }
        )
    }
}
/**
 * SHOPPING PERSO
 */

const J_SHOPPING_PERSO_HOME = '.j_shopping_perso'

function activerCarrouselShoppingPerso() {
    if (elementExistsInDOM(J_SHOPPING_PERSO_HOME)) {
        $(J_SHOPPING_PERSO_HOME).slick({
            lazyLoad: 'progressive',
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            slide: 'div',
            centerMode: true,
            autoplay: false,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true
                    }
                }
            ]
        })

        $('.carouselSelecPerso .slick-prev')
            .empty()
            .append(
                '<span><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none"><g clip-path="url(#clip0_927_5400)"><path d="M10.7596 2.85057L4.45249 9.08616L10.7596 15.3218L8.81312 17.2462L0.559569 9.08616L8.81312 0.926156L10.7596 2.85057Z" fill="white"/></g><defs><clipPath id="clip0_927_5400"><rect width="10.2" height="16.32" fill="white" transform="matrix(1 -1.27146e-07 -1.27146e-07 -1 0.55957 17.2462)"/></clipPath></defs></svg></span>'
            )
        $('.carouselSelecPerso .slick-next')
            .empty()
            .append(
                '<span><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none"><g clip-path="url(#clip0_927_5394)"><path d="M0.239456 15.3217L6.54653 9.08615L0.239454 2.85054L2.1859 0.926148L10.4395 9.08615L2.18591 17.2461L0.239456 15.3217Z" fill="white"/></g><defs><clipPath id="clip0_927_5394"><rect width="10.2" height="16.32" fill="white" transform="matrix(-1 9.53595e-08 9.53595e-08 1 10.4395 0.926147)"/></clipPath></defs></svg></span>'
            )
    }
}

/**
 * FUSION 3M / PERSONNAL SHOPPING QUIZZ
 */

const J_PQ_LISTE_TAILLES = '.j_pq_liste_tailles'
const J_FUSION3M_TAILLES = '.j_fusion3m_tailles'

function activerCarrouselTaille() {
    if (elementExistsInDOM(J_PQ_LISTE_TAILLES)) {
        $(J_PQ_LISTE_TAILLES).each(function(index, item) {
            $(item).slick({
                infinite: false,
                slidesToShow: 10,
                slidesToScroll: 4,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 8,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 7,
                            slidesToScroll: 3
                        }
                    }
                ]
            })
        })
        $('.pq_tailles .slick-prev')
            .empty()
            .append(
                '<svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 400.004 400.004" style="enable-background:new 0 0 400.004 400.004;" xml:space="preserve"> <g> <path style="fill:#000" d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /> </g></svg>'
            )
        $('.pq_tailles .slick-next')
            .empty()
            .append(
                '<svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path style="fill:#000;" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" /></svg>'
            )
    }

    if (elementExistsInDOM(J_FUSION3M_TAILLES)) {
        $(J_FUSION3M_TAILLES).each(function(index, item) {
            if (item.slick != null) {
                return
            }

            let slideStep = parseInt(item.dataset.slideStep)

            if (isNaN(slideStep)) {
                slideStep = 2
            }

            $(item).slick({
                infinite: false,
                variableWidth: true,
                slidesToShow: 6,
                slidesToScroll: slideStep,
                arrows: true,
                waitForAnimate: false,
                slide: 'div',
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2
                        }
                    }
                ]
            })
        })
        $('.fusionStep2__sizes .slick-prev')
            .empty()
            .append(
                '<svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 400.004 400.004" style="enable-background:new 0 0 400.004 400.004;" xml:space="preserve"> <g> <path style="fill:#959595" d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /> </g></svg>'
            )
        $('.fusionStep2__sizes .slick-next')
            .empty()
            .append(
                '<svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve"> <path style="fill:#959595;" d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111 C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587 c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" /></svg>'
            )
    }
}

/**
 * PRODUIT / MODZLAB
 */

const J_MULTIPLE_CAROUSEL = '.j_multiple_carousel'

function activerCarrouselProduitsSimilaires() {
    if (elementExistsInDOM(J_MULTIPLE_CAROUSEL)) {
        $(J_MULTIPLE_CAROUSEL).each(function(index, item) {
            $(item).slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            })
        })

        $('.pdts-sim .slick-prev')
            .empty()
            .append(
                '<span><svg version="1.1" x="0px" y="0px" viewBox="0 0 81.1 22.8" style="enable-background:new 0 0 81.1 22.8;" xml:space="preserve"> <g> <rect x="3.6" y="10.6" width="72.8" height="2"/> </g> <g> <path d="M70,18.4c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.2-1.1,0.2-1.4l6.4-4.6c0.2-0.1,0.3-0.3,0.3-0.4c0-0.1-0.1-0.3-0.3-0.4 l-6.4-4.7c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,0.9-0.5,1.4-0.2L77,9.6c0.7,0.5,1.1,1.2,1.1,2c0,0.8-0.4,1.5-1.1,2l-6.4,4.6 C70.4,18.3,70.2,18.4,70,18.4z"/> </g> </svg></span>'
            )
        $('.pdts-sim .slick-next')
            .empty()
            .append(
                '<span><svg version="1.1" x="0px" y="0px" viewBox="0 0 81.1 22.8" style="enable-background:new 0 0 81.1 22.8;" xml:space="preserve"> <g> <rect x="3.6" y="10.6" width="72.8" height="2"/> </g> <g> <path d="M70,18.4c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.2-1.1,0.2-1.4l6.4-4.6c0.2-0.1,0.3-0.3,0.3-0.4c0-0.1-0.1-0.3-0.3-0.4 l-6.4-4.7c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,0.9-0.5,1.4-0.2L77,9.6c0.7,0.5,1.1,1.2,1.1,2c0,0.8-0.4,1.5-1.1,2l-6.4,4.6 C70.4,18.3,70.2,18.4,70,18.4z"/> </g> </svg></span>'
            )
    }
}

const J_SINGLE_PRODUIT_CAROUSEL = '.j_single_produit_carousel'

function activerCarrouselProduitMobile() {
    if (elementExistsInDOM(J_SINGLE_PRODUIT_CAROUSEL)) {
        $(J_SINGLE_PRODUIT_CAROUSEL).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: 'div',
            arrows: false,
            autoplay: false,
            autoplaySpeed: 2000,
            dots: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        slidesToScroll: 1
                    }
                }
            ]
        })
    }
}

/**
 * CATALOGUE
 */

const J_SLIDER_FILTRETAILLE = '.j_slider_filtreTaille' // CATALOGUE

function activerCarrouselFiltresTaille() {
    if (elementExistsInDOM(J_SLIDER_FILTRETAILLE)) {
        $(J_SLIDER_FILTRETAILLE).each(function(index, item) {
            if (item.slick) {
                return
            }

            $(item).slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 3,
                arrows: true,
                autoplay: false,
                dots: false
            })
        })
    }
}

/**
 * MAISON SECONDE
 */

const J_SLIDER_AMBIANCE = '.j_slider_ambiance' // MAISON SECONDE

function activerCarouselSecondeMain() {
    if (elementExistsInDOM(J_SLIDER_AMBIANCE)) {
        $(J_SLIDER_AMBIANCE).each(function(index, item) {
            $(item).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                autoplay: true, //ici
                autoplaySpeed: 5000,
                dots: true,
                pauseOnHover: false,
                pauseOnFocus: false
            })
        })
    }
}

/**
 * QUI SOMMES NOUS
 */

const J_CARDS_SLIDER = '.j_cards_slider'

function activerCarrouselQuiSommesNous() {
    $(J_CARDS_SLIDER).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: 'ondemand',
        autoplay: true, //ici
        autoplaySpeed: 5000,
        dots: true,
        pauseOnHover: false,
        pauseOnFocus: false
    })
}

/**
 * BLOG INTERVIEWS
 */

const J_SINGLE_ITW_CAROUSEL_SALARIE_FOR = '.j_single_itw_carousel_salarie-for'
const J_SINGLE_ITW_CAROUSEL_SALARIE_NAV = '.j_single_itw_carousel_salarie-nav'
const J_SINGLE_ITW_CAROUSEL_CLIENT_FOR = '.j_single_itw_carousel_client-for'
const J_SINGLE_ITW_CAROUSEL_CLIENT_NAV = '.j_single_itw_carousel_client-nav'
const J_SINGLE_ITW_CAROUSEL_BOUTIQUE_FOR = '.j_single_itw_carousel_boutique-for'
const J_SINGLE_ITW_CAROUSEL_BOUTIQUE_NAV = '.j_single_itw_carousel_boutique-nav'

function activerCarrouselBlogInterviews() {
    const config = {
        selectedVideo: (selector) => ({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: selector
        }),
        navVideo: (selector) => ({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: selector,
            dots: true,
            centerMode: true,
            lazyLoad: 'progressive',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true
                    }
                }
            ]
        })
    }

    const carrousels = [
        {
            selected: J_SINGLE_ITW_CAROUSEL_SALARIE_FOR,
            nav: J_SINGLE_ITW_CAROUSEL_SALARIE_NAV
        },
        {
            selected: J_SINGLE_ITW_CAROUSEL_CLIENT_FOR,
            nav: J_SINGLE_ITW_CAROUSEL_CLIENT_NAV
        },
        {
            selected: J_SINGLE_ITW_CAROUSEL_BOUTIQUE_FOR,
            nav: J_SINGLE_ITW_CAROUSEL_BOUTIQUE_NAV
        }
    ]

    carrousels.forEach((x) => {
        if (!elementExistsInDOM(x.selected)) {
            return
        }

        $(x.selected).slick(config.selectedVideo(x.nav))

        $(x.nav).slick(config.navVideo(x.selected))
    })
}

//slick slider pour ambiance partial Vente flash
function activerCarouselHomeAmbianceVentelash() {
    $(document).ready(function() {
        const VenteFlashSlider = '.slider-container'
        $(VenteFlashSlider).slick({
            centerMode: false,
            slidesToShow: 3,
            autoplay: true,
            speed: 8000,
            cssEase: 'linear',
            slidesToScroll: 1,
            autoplaySpeed: 0,
            vertical: true,
            infinite: true,
            arrows: false,
            buttons: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        vertical: false
                    }
                }
            ]
        })
    })
}
//slick slider boutique de noel

const J_SLIDER_BDN = '.j_slider_bdn' // MAISON SECONDE

function activerCarouselBdn() {
    if (elementExistsInDOM(J_SLIDER_BDN)) {
        $(J_SLIDER_BDN).each(function(index, item) {
            $(item).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                autoplay: true, //ici
                autoplaySpeed: 5000,
                dots: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            autoplaySpeed: 3000
                        }
                    }
                ]
            })
        })
    }
}

// slick slider page nos pepites

const J_SLIDER_PEPITES = '.j_slider_pepites'

function activerSliderPepites() {
    if (elementExistsInDOM(J_SLIDER_PEPITES)) {
        $(J_SLIDER_PEPITES).each(function(index, item) {
            $(item).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            })
        })
    }
}

/**
panier cross-sell
**/

const J_SLIDER_CROSS_SELL = '.j_slider_cross_sell'

function activerCarrouselCrossSell() {
    if (elementExistsInDOM(J_SLIDER_CROSS_SELL)) {
        $(J_SLIDER_CROSS_SELL).each(function(index, item) {
            $(item).slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                slide: 'div',
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true

                        }
                    }
                ]
            })
        })

        $('.pdts-sim .slick-prev')
            .empty()
            .append(
                '<span><svg version="1.1" x="0px" y="0px" viewBox="0 0 81.1 22.8" style="enable-background:new 0 0 81.1 22.8;" xml:space="preserve"> <g> <rect x="3.6" y="10.6" width="72.8" height="2"/> </g> <g> <path d="M70,18.4c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.2-1.1,0.2-1.4l6.4-4.6c0.2-0.1,0.3-0.3,0.3-0.4c0-0.1-0.1-0.3-0.3-0.4 l-6.4-4.7c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,0.9-0.5,1.4-0.2L77,9.6c0.7,0.5,1.1,1.2,1.1,2c0,0.8-0.4,1.5-1.1,2l-6.4,4.6 C70.4,18.3,70.2,18.4,70,18.4z"/> </g> </svg></span>'
            )
        $('.pdts-sim .slick-next')
            .empty()
            .append(
                '<span><svg version="1.1" x="0px" y="0px" viewBox="0 0 81.1 22.8" style="enable-background:new 0 0 81.1 22.8;" xml:space="preserve"> <g> <rect x="3.6" y="10.6" width="72.8" height="2"/> </g> <g> <path d="M70,18.4c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.2-1.1,0.2-1.4l6.4-4.6c0.2-0.1,0.3-0.3,0.3-0.4c0-0.1-0.1-0.3-0.3-0.4 l-6.4-4.7c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,0.9-0.5,1.4-0.2L77,9.6c0.7,0.5,1.1,1.2,1.1,2c0,0.8-0.4,1.5-1.1,2l-6.4,4.6 C70.4,18.3,70.2,18.4,70,18.4z"/> </g> </svg></span>'
            )
    }
}

// const J_SINGLE_CROSS_SELL = '.j_single_cross_sell'
//
// function activerCarrouselCrossSellMobile() {
//     if (elementExistsInDOM(J_SINGLE_CROSS_SELL)) {
//         $(J_SINGLE_CROSS_SELL).slick({
//             infinite: true,
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             slide: 'div',
//             arrows: false,
//             autoplay: false,
//             autoplaySpeed: 2000,
//             dots: true,
//             lazyLoad: 'ondemand',
//             responsive: [
//                 {
//                     breakpoint: 1024,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1
//                     }
//                 },
//                 {
//                     breakpoint: 640,
//                     settings: {
//                         slidesToShow: 1,
//                         arrows: false,
//                         slidesToScroll: 1
//                     }
//                 }
//             ]
//         })
//     }
// }


export default {
    activerCarrouselShoppingPerso: activerCarrouselShoppingPerso,
    activerCarrouselTaille: activerCarrouselTaille,
    activerCarrouselQuiSommesNous: activerCarrouselQuiSommesNous,
    activerCarrouselBlogInterviews: activerCarrouselBlogInterviews,
    activerCarrouselProduitsSimilaires: activerCarrouselProduitsSimilaires,
    activerCarrouselFiltresTaille: activerCarrouselFiltresTaille,
    activerCarrouselProduitMobile: activerCarrouselProduitMobile,
    activerCarouselSecondeMain: activerCarouselSecondeMain,
    activerCarrouselInfluenceurs: activerCarrouselInfluenceurs,
    activerCarrouselInfluenceuses: activerCarrouselInfluenceuses,
    activerCarouselHomeAmbianceVentelash: activerCarouselHomeAmbianceVentelash,
    activerCarouselBdn: activerCarouselBdn,
    activerSliderPepites: activerSliderPepites,
    activerCarrouselCrossSell: activerCarrouselCrossSell
}
